/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SportGymBarbellIcon16Light } from './SportGymBarbellIcon16Light';
import { SportGymBarbellIcon16Regular } from './SportGymBarbellIcon16Regular';
import { SportGymBarbellIcon16Solid } from './SportGymBarbellIcon16Solid';
import { SportGymBarbellIcon20Light } from './SportGymBarbellIcon20Light';
import { SportGymBarbellIcon20Regular } from './SportGymBarbellIcon20Regular';
import { SportGymBarbellIcon20Solid } from './SportGymBarbellIcon20Solid';
import { SportGymBarbellIcon24Regular } from './SportGymBarbellIcon24Regular';
import { SportGymBarbellIcon24Solid } from './SportGymBarbellIcon24Solid';
import { SportGymBarbellIcon32Regular } from './SportGymBarbellIcon32Regular';
import { SportGymBarbellIcon64Regular } from './SportGymBarbellIcon64Regular';
var sizes = {
    16: {
        light: SportGymBarbellIcon16Light,
        regular: SportGymBarbellIcon16Regular,
        solid: SportGymBarbellIcon16Solid,
    },
    20: {
        light: SportGymBarbellIcon20Light,
        regular: SportGymBarbellIcon20Regular,
        solid: SportGymBarbellIcon20Solid,
    },
    24: {
        regular: SportGymBarbellIcon24Regular,
        solid: SportGymBarbellIcon24Solid,
    },
    32: {
        regular: SportGymBarbellIcon32Regular,
    },
    64: {
        regular: SportGymBarbellIcon64Regular,
    },
};
export var SportGymBarbellIcon = forwardRef('SportGymBarbellIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
